export const BuyProposalType = Object.freeze({
    S: Symbol('S'),
    F: Symbol('F'),
    P: Symbol('P'),
});

export function getTypeText(status) {
    return {
        [BuyProposalType.S]: 'Sprzedaż',
        [BuyProposalType.F]: 'Darmowa utylizacja',
        [BuyProposalType.P]: 'Płatna utylizacja',
    }[BuyProposalType[status]];
}